export default {
  meta: {
    title: '周边查询',
    url: '/surround', // 埋点用，记录所属模块
  }
};
